import { ApiResponse, postRequest } from "@/data/apiClient";

export const userLogout = async (): Promise<ApiResponse<unknown>> =>
  postRequest("user/logout", {});
